export const getImageAsDataUrl = async (
  event: any,
  callBack: any,
  maxLimit?: number
) => {
  var input = event;

  let promises = [];
  for (let file of input) {
    if (file.type.includes("image/")) {
      let filePromise = new Promise((resolve) => {
        let reader = new FileReader();
        reader.onload = (e: any) =>
          resolve({
            dataUrl: e.target.result,
            file: file,
            fileName: input.name,
          });
        reader.readAsDataURL(file);
      });
      promises.push(filePromise);
    }
  }

  if (maxLimit) {
    promises = promises.filter((_, iDx: number) => iDx <= maxLimit - 1);
  }

  await Promise.all(promises).then((fileContents) => {
    callBack(fileContents);
  });
};

export const imageLoader = ({ src, width }: any) => {
  return `${src}?w=${width}&q=${75}`;
};

function getFirstCharacters(sentence: any) {
  const words = sentence.split(" ");
  const firstCharacters = words.map((word: any) => word.charAt(0));
  return firstCharacters.join("").slice(0, 2);
}
export const AvatarProps = (
  srcList: any,
  name: string,
  bgcolor: string,
  sx: any = {}
) => {
  const res: any = {
    sx: {
      bgcolor,
      ...sx,
    },
  };
  if (srcList && srcList?.length) {
    res["src"] = srcList.reduce((acc: any, cur: any) => acc || cur);
  } else if (name?.length) {
    res["children"] = getFirstCharacters(name);
  }
  return res;
};
